import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
import { Select } from 'antd';
import PropTypes from 'prop-types';

// Import helpers
import { REQUIRED_MARK } from 'components/helpers/variables';

const MultiSelectLabel = ({
	input,
	id,
	label,
	required = true,
	placeholder = '',
	labelColumn = 2,
	inputColumn = 10,
	isEditDisabled = false,
	mode = 'multiple',
	showSearch = false,
	children,
	meta: { touched, error, submitError },
	onSearch,
	fieldInfo = null,
	onChangeCallback = () => {},
	dropdownStyle = null,
	requiredField = false,
	...otherProps
}) => {
	const handleOnChange = (event) => {
		input.onChange(event);
		onChangeCallback(event);
	};
	return (
		<FormGroup row className={`${touched && error && 'has-error'}`}>
			{isEditDisabled && <div className="form-group__disabled">&nbsp;</div>}
			<Label
				for={id}
				sm={labelColumn}
				className="col-form-label col-form-label-lg"
			>
				{label} {requiredField && REQUIRED_MARK}
			</Label>

			<Col sm={inputColumn}>
				<Select
					{...input}
					showSearch
					value={input.value || []}
					mode={mode}
					style={{ width: '100%' }}
					placeholder={placeholder}
					className="m-b-sm"
					onSearch={onSearch}
					dropdownStyle={dropdownStyle}
					onChange={handleOnChange}
					{...otherProps}
				>
					{children}
				</Select>
				{touched && (error || submitError) && (
					<span
						data-testid={`input-error-${input.name}`}
						className="input-error d-block"
					>
						{error || submitError}
					</span>
				)}
				{fieldInfo && (
					<span className="input-info m-b-sm">
						<i className="fa fa-info-circle m-r-sm"></i>
						{fieldInfo}
					</span>
				)}
			</Col>
		</FormGroup>
	);
};

MultiSelectLabel.defaultProps = {
	onSearch: () => {}
};

MultiSelectLabel.propTypes = {
	input: PropTypes.object,
	id: PropTypes.string,
	label: PropTypes.string,
	required: PropTypes.bool,
	placeholder: PropTypes.string,
	labelColumn: PropTypes.number,
	inputColumn: PropTypes.number,
	isEditDisabled: PropTypes.bool,
	mode: PropTypes.string,
	children: PropTypes.array,
	meta: PropTypes.object,
	onSearch: PropTypes.func,
	otherProps: PropTypes.object,
	showSearch: PropTypes.bool,
	fieldInfo: PropTypes.string,
	requiredField: PropTypes.bool
};

export default MultiSelectLabel;
